import { DEFAULT_VIEW_SETTINGS, type ViewSettings } from "@ext/markdown/elements/view/models/ViewSettings";
import { createJSONStorage, persist } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { useStoreWithEqualityFn } from "zustand/traditional";
import { createStore } from "zustand/vanilla";

const STORE_NAME = "catalog-report-settings-state";
const STORE_VERSION = 1;

type CatalogReportSettingsStore = {
	byCatalog: Record<string, ViewSettings>;
	update: (catalogName: string, patch: Partial<ViewSettings>) => void;
};

export const catalogReportSettingsStore = createStore<CatalogReportSettingsStore>()(
	persist(
		(set) => ({
			byCatalog: {},
			update: (catalogName, patch) =>
				set((state) => ({
					byCatalog: {
						...state.byCatalog,
						[catalogName]: { ...(state.byCatalog[catalogName] ?? DEFAULT_VIEW_SETTINGS), ...patch },
					},
				})),
		}),
		{
			name: STORE_NAME,
			version: STORE_VERSION,
			storage: createJSONStorage(() => localStorage),
		},
	),
);

export const useCatalogReportSettingsStore = <T>(selector: (state: CatalogReportSettingsStore) => T): T =>
	useStoreWithEqualityFn(catalogReportSettingsStore, selector, shallow);

export const updateCatalogReportSettings = (catalogName: string, patch: Partial<ViewSettings>) =>
	catalogReportSettingsStore.getState().update(catalogName, patch);
